import React, { Fragment, useState, useEffect } from 'react'
import { IntlProvider } from 'react-intl'
import { ThemeProvider } from 'styled-components'

import * as appThemes from '../ui/theme'
import { GlobalStyle } from '../ui/GlobalStyle'
import useDarkColorScheme from '../components/hooks/useDarkColorScheme'

import messages from '../locale-data/messages'
import LaunchDarklyProvider from './launchDarkly.tsx'
//
// This ProviderWrapper exists so that intl and theme providers
// can be shared with the app and with the docz docs.
//

const intlLocale = 'en'

const ProviderWrapper = ({ children }) => {
  const prefersDarkColorScheme = useDarkColorScheme()
  const [currentTheme, setCurrentTheme] = useState(appThemes.theme)

  useEffect(() => {
    setCurrentTheme(
      prefersDarkColorScheme ? appThemes.themeDark : appThemes.theme,
    )

    return undefined
  }, [prefersDarkColorScheme])

  return (
    <IntlProvider
      messages={messages[intlLocale]}
      locale={intlLocale}
      defaultLocale="en">
      <LaunchDarklyProvider>
        <ThemeProvider theme={currentTheme}>
          <Fragment>
            {children}
            <GlobalStyle />
          </Fragment>
        </ThemeProvider>
      </LaunchDarklyProvider>
    </IntlProvider>
  )
}

export default ProviderWrapper
